import { render, staticRenderFns } from "./blok-download-button.vue?vue&type=template&id=a40eb3da&scoped=true"
import script from "./blok-download-button.vue?vue&type=script&lang=js"
export * from "./blok-download-button.vue?vue&type=script&lang=js"
import style0 from "./blok-download-button.vue?vue&type=style&index=0&id=a40eb3da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40eb3da",
  null
  
)

export default component.exports